var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    width: 44,
    height: 44,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Folder 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Folder 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "none",
    d: "m-2.3 4.7h40.6v40.6h-40.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Layer",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    cx: 23.1,
    cy: 30.1,
    r: 5.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m26.5 34.3v7.6l-3.4-2.5-3.4 2.5v-7.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m14.6 36.8h-8.4q-0.7 0-1.3-0.2-0.7-0.3-1.1-0.7-0.5-0.5-0.8-1.1-0.2-0.7-0.2-1.3v-17c0-1.8 2-3.3 3.4-3.3h23.6q0.7 0 1.3 0.2 0.7 0.3 1.1 0.7 0.5 0.5 0.8 1.1 0.2 0.7 0.2 1.3v17q0 0.4-0.1 0.8-0.1 0.5-0.3 0.9-0.2 0.3-0.6 0.7-0.3 0.3-0.7 0.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m7.8 19.9h20.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m7.8 25h5.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m7.8 30.1h3.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Folder 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "none",
    d: "m21 0h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m31.3 4.3c0.5-1.7 2.9-1.7 3.4 0q0.1 0.4 0.3 0.7 0.3 0.3 0.7 0.5 0.4 0.2 0.8 0.1 0.4 0 0.7-0.2c1.6-1 3.4 0.8 2.4 2.4q-0.2 0.3-0.2 0.7-0.1 0.4 0.1 0.8 0.2 0.4 0.5 0.7 0.3 0.2 0.7 0.3c1.7 0.5 1.7 2.9 0 3.4q-0.4 0.1-0.7 0.3-0.3 0.3-0.5 0.7-0.2 0.4-0.1 0.8 0 0.4 0.2 0.7c1 1.6-0.8 3.4-2.4 2.4q-0.3-0.2-0.7-0.2-0.4-0.1-0.8 0.1-0.4 0.2-0.7 0.5-0.2 0.3-0.3 0.7c-0.5 1.7-2.9 1.7-3.4 0q-0.1-0.4-0.3-0.7-0.3-0.3-0.7-0.5-0.4-0.2-0.8-0.1-0.4 0-0.7 0.2c-1.6 1-3.4-0.8-2.4-2.4q0.2-0.3 0.2-0.7 0.1-0.4-0.1-0.8-0.2-0.4-0.5-0.7-0.3-0.2-0.7-0.3c-1.7-0.5-1.7-2.9 0-3.4q0.4-0.1 0.7-0.3 0.3-0.3 0.5-0.7 0.2-0.4 0.1-0.8 0-0.4-0.2-0.7c-1-1.6 0.8-3.4 2.4-2.4 1 0.6 2.2 0.1 2.5-1.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Layer",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    cx: 33,
    cy: 12,
    r: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditSetting);
export default __webpack_public_path__ + "static/media/audit_setting.f3235531f3e8dda27e30083fdcdad405.svg";
export { ForwardRef as ReactComponent };